import React, { useCallback, useContext, useEffect, useState } from 'react';
import { ShopOutlined, SyncOutlined, ReloadOutlined } from '@ant-design/icons';
import { Button, PageHeader, Table, Layout } from 'antd';
import { apiClient, apiErrorMessage, hasPermission } from '../../../utils';
import { UserContext } from '../../contexts';
import { Supplier } from '../../../models/supplier';

const { Content } = Layout;
export function SuppliersPage() {
  const { user } = useContext(UserContext);
  const [suppliers, setSuppliers] = useState<Supplier[]>();
  const [canEdit, setCanEdit] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setCanEdit(hasPermission(user, 'suppliers.sync_sap'));
  }, [user]);

  const loadSuppliers = useCallback(() => {
    setLoading(true);
    apiClient
      .get(`suppliers`)
      .then((response: any) => {
        const responseSuppliers: Supplier[] = response.data;
        const responseData = responseSuppliers.map(supplier => {
          return {
            key: supplier.id,
            ...supplier,
          };
        });
        setSuppliers(responseData);
        setLoading(false);
      })
      .catch((reason: any) => {
        setLoading(false);
        apiErrorMessage(reason);
      });
  }, []);

  useEffect(() => {
    loadSuppliers();
  }, [loadSuppliers]);

  const onRefreshClick = () => {
    loadSuppliers();
  };

  const onSyncClick = () => {};

  const tableColumns: any[] = [
    {
      title: 'Tedarikçi no',
      dataIndex: 'code',
      key: 'code',
    },
    {
      title: 'İsim',
      dataIndex: 'name',
      key: 'name',
    },
  ];

  return (
    <>
      <PageHeader
        title={
          <>
            <ShopOutlined /> Tedarikçiler
          </>
        }
        extra={[
          <Button key="refresh" onClick={onRefreshClick} icon={<ReloadOutlined />}>
            Yenile
          </Button>,
          <>
            {canEdit && (
              <Button type="primary" key="sync" onClick={onSyncClick} icon={<SyncOutlined />}>
                SAP ile eşle
              </Button>
            )}
          </>,
        ]}
      />
      <Content>
        <Table columns={tableColumns} dataSource={suppliers} loading={loading} pagination={false} />
      </Content>
    </>
  );
}
